// useInteractionTrackingFlush.js
// Mount this once, high up (e.g. in App.js's Layout), passing in whether the client
// is currently logged in - same pattern as useHeartbeat/useSectionTrackingFlush.

import { useEffect } from "react";
import { flushInteractionEvents } from "./interactionEventQueue";

const FLUSH_INTERVAL_MS = 18000;

export default function useInteractionTrackingFlush(enabled) {
  useEffect(() => {
    if (!enabled) return;

    const intervalId = setInterval(() => {
      flushInteractionEvents();
    }, FLUSH_INTERVAL_MS);

    function handleVisibilityChange() {
      if (document.visibilityState === "hidden") {
        flushInteractionEvents();
      }
    }
    document.addEventListener("visibilitychange", handleVisibilityChange);

    function handleBeforeUnload() {
      flushInteractionEvents();
    }
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [enabled]);
}